import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import {
  buildTenantAppPath,
  resolveTenantSlug,
  stripTenantPrefixFromPathname,
} from 'shared/utils/tenantPath';
import { isTenantRouteKey } from 'shared/utils/tenantRoute';

/**
 * Hook for tenant-prefixed in-app paths after login.
 * tp('/dashboard') → '/datahouse/dashboard'
 */
export function useTenantPath() {
  const params = useParams();
  const paramKey = params.tenantKey || params.tenantId || null;
  const slug = useMemo(() => {
    if (paramKey && isTenantRouteKey(paramKey)) {
      return resolveTenantSlug(paramKey);
    }
    return resolveTenantSlug();
  }, [paramKey]);

  const tp = useMemo(() => {
    return (appPath) => buildTenantAppPath(appPath, slug);
  }, [slug]);

  return { slug, tp, stripTenantPrefixFromPathname };
}
